import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Toasts
  checkInErrorToast: '<p>Invalid checkin date</p>',
});

export default messages;
